export const LDS_PACKAGE    = Symbol('LDS_PACKAGE');
export const GDS_PACKAGE    = Symbol('GDS_PACKAGE');
export const AGENCY2000     = Symbol('AGENCY2000');
export const RENT_CAR       = Symbol('RENT_CAR');
export const BEPRO          = Symbol('BEPRO');
export const TRAVEL_FUSION  = Symbol('TRAVEL_FUSION');
export const YAYA           = Symbol('YAYA');
export const MERLINX        = Symbol('MERLINX');
export const MAKE_MY_TRIP   = Symbol('MAKE_MY_TRIP');
export const COMBINED       = Symbol('COMBINED');
export const OFFLINE        = Symbol('OFFLINE');
export const SHIRBIT        = Symbol('SHIRBIT');
export const GOGLOBAL       = Symbol('GOGLOBAL');
export const A2K            = Symbol('A2K');
export const BUS            = Symbol('BUS');